import EventBus from '@/h5/utils/eventBus'
import { debounce } from 'lodash'
/**
 * 上报点击事件
 * @param {*} events
 */
export const emitClickEvents = debounce(async (events, failEvents) => {
  console.log('初始化页面事件', events, failEvents)
  if (!EventBus || !events || !events.length) return
  const clickEvents = events.filter((event) => event.eventType === 'click')
  for (let i = 0; i < clickEvents.length; i++) {
    const event = clickEvents[i]
    const type = event.type.replace(/([A-Z])/g, '_$1').toUpperCase()
    try {
      await EventBus.$emit(`EVENT_${type}`, event.value, event.subValue)
    } catch (e) {
      console.log('事件停止执行', e)
      dealWithFailEvents(event.type, failEvents, e)
      break
    }
  }
}, 500)

/**
 * 事件注册
 * @param {*} events
 */
export const emitEvents = async (events, failEvents) => {
  console.log('初始化页面事件', events, failEvents)
  if (!EventBus || !events || !events.length) return
  const filterClickEvents = events.filter((event) => event.eventType === 'click')
  let isFail = false
  for (let i = 0; i < filterClickEvents.length; i++) {
    const event = filterClickEvents[i]
    const type = event.type.replace(/([A-Z])/g, '_$1').toUpperCase()
    try {
      console.log('emitEvents--->>>', type, event.value, event.subValue)
      await EventBus.$emit(`EVENT_${type}`, event.value, event.subValue)
    } catch (e) {
      console.log('事件停止执行', e)
      isFail = true
      dealWithFailEvents(event.type, failEvents, e)
      break
    }
  }
  if (isFail) {
    throw new Error('event is fail')
  }
}

/**
 * 失败事件处理
 * @param {*} type
 * @param {*} events
 */
const dealWithFailEvents = async (type, failEvents, e) => {
  /* 是否满足type条件 */
  if (!['componentFunc', 'unityApi', 'api', 'skipAction'].includes(type)) {
    return
  }
  /* 找到对应type下的failEvent */
  const failEvent = failEvents && failEvents?.find((event) => event.type === type)
  if (!failEvent?.errorCodes?.length) {
    return
  }
  /* 根据errCode匹配对应的错误码事件，遍历执行，同时保持事件错误中止执行的机制 */
  let events = []
  if (type === 'skipAction') {
    if (e.message === 'currencyPayResult not sufficient funds') {
      const findEvents = failEvent.errorCodes.find((err) => err.name === '2')?.events || []
      events = findEvents
    }
  } else if (['componentFunc', 'unityApi', 'api'].includes(type)) {
    const findEvents = failEvent.errorCodes.find((err) => err.name === e.message)?.events || []
    events = findEvents
  }
  if (events?.length) {
    for (let i = 0; i < events.length; i++) {
      const event = events[i]
      const eType = event.type.replace(/([A-Z])/g, '_$1').toUpperCase()
      try {
        await EventBus.$emit(`EVENT_${eType}`, event.value, event.subValue)
      } catch (e) {
        console.log('事件停止执行', e)
        break
      }
    }
  }
}
